import { useFm } from '@web3/base-hooks';
import EmptySvg from '@/assets/svg/empty.svg';

export default function Empty() {
  const t = useFm();

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <EmptySvg />
      <p className="text-bds-gray-t2 text-xs font-medium">{t('noDataFound')}</p>
    </div>
  );
}
